<template>
<div>
  <!--<div v-show="step === 0" class="double-card-page-container"  >-->
  <div v-show="step === 0">
    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--12-col">
        <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
          <div class="ga-form-title">
            <h2 class="ga-title-text">{{'newDelayed.label.service.title' | label}}</h2>
          </div>
          <div class="mdl-card__supporting-text fill">
            {{{'newDelayed.label.service.description.text' | label}}}
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--4-col  mdl-cell--12-col-tablet">
        <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
          <div class="mdl-tabs mdl-js-tabs">
            <div class="mdl-tabs__tab-bar ga-form-title">
              <a href="#detailsTab1" class="mdl-tabs__tab is-active">{{'newDelayed.label.details' | label}}</a>
              <a href="#faq" class="mdl-tabs__tab">{{'newDelayed.label.faq' | label}}</a>
            </div>
            <div class="mdl-tabs__panel is-active" id="detailsTab1">
              <delayed-details :tab="tab"></delayed-details>
            </div>
            <div class="mdl-tabs__panel" id="faq">
              <faq service="delayed"></faq>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--8-col" v-show="showRegForm">
        <register-form :is-visible="logged == null" with-credentials></register-form>
      </div>
      <div class="mdl-cell mdl-cell--8-col" v-show="showMessageForm">
        <delayed-message-form :registration="logged == null"></delayed-message-form>
      </div>
    </div>
  </div>

  <div v-show="step === 1" class="card-page-container alert"  >
    <div class="mdl-grid fill">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert title="register.verify.message.title" message="register.verify.message.text" goto="/"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
  </div>
 <!--<div v-show="step === 1" class=""  >-->
   <!--<payment></payment>-->
  <!--</div>-->

</template>

<script>
  var auth = require('api/Auth')
  var api = require('api')
  var local = require('common/store/local')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
      // force goto new registration form
      var redirect = '/app/register'
      this.$router.go(redirect)
    },
    components: {
      'date-picker': require('vue-datepicker'),
      alert: require('c/components/Alert'),
      delayedMessageForm: require('c/forms/DelayedMessageForm'),
      'delayed-details': require('c/segments/DelayedDetails'),
      'faq': require('c/segments/FAQ'),
      'register-form': require('c/forms/RegisterForm')
    },
    methods: {
      onError: function (err) {
        if (err.data.message === 'register.error.usernameExists') {
          this.showRegForm = true
          this.showMessageForm = false
          this.$dispatch('loading', false)
          this.$broadcast('username-validation-fail', err.data.message)
        } else {
          this.$dispatch('show-error', err.data)
        }
      }
    },
    events: {
      'message-valid': function (message) {
        var self = this
        this.message = message
        this.message.userId = this.user.id
        self.$dispatch('loading', true)
        var data = {}
        data.user = self.user
        data.user.langCode = local.get('client.language') || 'en'
        data.message = self.message
        api.User.createWithMessage(data).then(function () {
          self.$dispatch('loading', false)
//            self.$broadcast('pay', self.user)
          self.step = 1
        }, self.onError)
      },
      'registration-valid': function (user) {
//        this.user = user
//        this.showMessageForm = true
        var self = this
        self.$dispatch('loading', true)
//        this.showRegForm = false
        auth.validate(user, function () {
          self.user = user
          self.user['service'] = 'DELAYED'
          self.$dispatch('loading', false)
          self.showRegForm = false
          self.showMessageForm = true
//            self.$broadcast('pay', self.user)
        }, self.onError)
      },
      'back-to-reg': function () {
        this.showMessageForm = false
        this.showRegForm = true
      }
//      ,
//      'registration-valid': function (user) {
//        var self = this
//        self.$dispatch('loading', true)
//        auth.register(user, function (userId) {
//          self.message.userId = userId
//          api.Message.save(self.message).then(function () {
//            self.$dispatch('loading', false)
//            self.step = 2
//          }, self.onError)
//        }, self.onError)
//      }
    },
    computed: {
      tab: function () {
        return this.showRegForm ? '0' : '1'
      }
    },
    data: function () {
      return {
        message: {},
        step: 0,
        showMessageForm: this.logged != null,
        showRegForm: this.logged == null
      }
    }
  }
</script>

<style scoped>

  .attachment-label {
    line-height: 40px;
  }

  .delivery-label {
    line-height: 38px;
  }

  .form-label {
    color: rgba(0, 0, 0, .26);
    font-size: 16px !important;
  }

  .textfield-padding-fix {
    margin-top: -20px;
  }

  .mdl-checkbox {
    margin-left: 10px;
  }

  .mdl-cell .card-page-container {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// NewDelayed.vue?3b5f6660